import { GetStaticProps, GetStaticPaths } from 'next';
import { NextSeo } from 'next-seo';

import AggregateLayout from '~/components/discussions/AggregateLayout';

import {
  DEAL_COMMENT_TYPE,
  DISCUSSION,
  REVIEW_SORT_OPTIONS,
} from '~/lib/discussions/constants';
import { getDealStaticPaths, withDealStaticProps } from '~/lib/product/fetch';
import { Deal } from '~/types/deal';

export const getStaticProps: GetStaticProps = withDealStaticProps;
export const getStaticPaths: GetStaticPaths = getDealStaticPaths;

function ReviewAggregatePage({ deal }: { deal: Deal }) {
  return (
    <>
      <NextSeo title={`${deal.public_name} Ratings & reviews`} />
      <AggregateLayout
        deal={deal}
        title="Ratings & reviews"
        discussionType={DISCUSSION.REVIEWS}
        commentType={DEAL_COMMENT_TYPE.REVIEW}
        sortOptions={REVIEW_SORT_OPTIONS}
      />
    </>
  );
}

export default ReviewAggregatePage;
